import { sentenceCase } from "change-case-all";
import { Grid, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";

import { TextField } from "../../../../components";
import { colors } from "../../../css components/Style";

function Range({ state, dispatch, field, editState, formikProps }) {
  const [input, setInput] = useState({});
  const [message, setMessage] = useState({});
  const [values, setValues] = useState({
    min: "",
    max: "",
  });

  function handleMandate(name) {
    let value = false;
    let key = "mandatory";
    dispatch({
      type: "CALCULATE_PERCENTAGE",
      payload: { value, name, key },
    });
  }

  const handleFieldChange = (value, name, key) => {
    if (
      !input?.[field.name]?.value?.[field.options[0].value] &&
      !input[field.name]?.value?.[field.options[1].value]
    ) {
      let noRange = "empty";
      dispatch({
        type: "RANGE_UPDATE",
        payload: { value, name, key, noRange },
      });
      handleMandate(name);
    } else {
      dispatch({ type: "RANGE_UPDATE", payload: { value, name, key } });
    }
  };

  useEffect(() => {
    if (state[field.name]) {
      setInput((prev) => ({
        ...prev,
        [field.name]: state[field.name],
      }));
    }
  }, [state, field.name]);

  function handleValueValidation(num1, num2 = 0, field, key) {
    let { min_default_val, max_default_val } = field;

    num1 = parseInt(num1);
    num2 = parseInt(num2);

    const newMessages = { ...message };
    const fieldMessages = newMessages[field.name] || {};
    let error = false;

    if (isNaN(num1) || isNaN(num2)) {
      fieldMessages[key] = sentenceCase("Please enter digits");
      error = true;
    }

    if (num1 && num2 && num1 > num2) {
      fieldMessages[key] = sentenceCase("Min should be less than max");
      error = true;
    }

    if (num1 < min_default_val || num1 > max_default_val) {
      fieldMessages[key] = sentenceCase(
        `Min should be between ${min_default_val} and ${max_default_val}.`
      );
      error = true;
    }

    if (num2 && (num2 < min_default_val || num2 > max_default_val)) {
      fieldMessages[key] = sentenceCase(
        `Max should be between ${min_default_val} and ${max_default_val}.`
      );
      error = true;
    }

    if (error) {
      newMessages[field.name] = fieldMessages;
    } else {
      delete newMessages[field.name]; // ✅ Delete entire field if inputs are valid and num1 < num2
    }

    setMessage(newMessages);
  }

  return (
    <Fragment>
      <Grid size={6}>
        <Grid container spacing={4}>
          {/* <Grid size={12} style={{ paddingTop: "0px" }}>
            <Mandatory
              dispatch={dispatch}
              state={state}
              editState={editState}
              field={field}
              formikProps={formikProps}
            />
          </Grid> */}

          <Grid size={6}>
            <TextField
              value={input?.[field.name]?.value?.[field.options[0].value]}
              size="small"
              label={field.options[0].label}
              onBlur={(e) => {
                handleFieldChange(
                  input[field.name]?.value?.[field.options[0].value],
                  field.name,
                  `${field.options[0].value}`
                );
              }}
              onChange={(e) => {
                const { value } = e.target;

                setInput((prev) => ({
                  ...prev,
                  [field.name]: {
                    value: {
                      ...input[field.name]?.value,
                      [field.options[0].value]: value,
                    },
                  },
                }));

                handleValueValidation(
                  e.target.value,
                  input?.[field.name]?.value?.[field.options[1].value],
                  field,
                  field.options[0].value
                );
              }}
              name={`${field.name}.value.${field.options[0].value}`}
              placeholder={field.options[0].label}
              disabled={!editState}
            />

            <Typography color={colors.error} variant="caption">
              {message[field.name]?.[field.options[0].value]}
            </Typography>
          </Grid>

          <Grid size={6}>
            <TextField
              size="small"
              label={field.options[1].label}
              onBlur={(e) => {
                handleFieldChange(
                  input[field.name]?.value?.[field.options[1].value],
                  field.name,
                  `${field.options[1].value}`
                );
              }}
              onChange={(e) => {
                const { value } = e.target;

                setInput((prev) => ({
                  ...prev,
                  [field.name]: {
                    value: {
                      ...input[field.name]?.value,
                      [field.options[1].value]: e.target.value,
                    },
                  },
                }));

                handleValueValidation(
                  input?.[field.name]?.value?.[field.options[0].value],
                  e.target.value,
                  field,
                  field.options[1].value
                );
              }}
              value={input?.[field.name]?.value?.[field.options[1].value]}
              name={`${field.name}.value.${field.options[1].value}`}
              placeholder={field.options[1].label}
              disabled={!editState}
            />

            <Grid size={12}>
              <Typography color={colors.error} variant="caption">
                {message[field.name]?.[field.options[1].value]}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default Range;
